import { Id, Tag } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";
import { LinkedProject } from "../linkers/types";

function removeTagFromProject(httpClient: HttpClient) {
  return (tag: Tag, projectId: Id) =>
    httpClient
      .sendHttpRequest<LinkedProject>({
        endpoint: `/projects/${projectId}`,
        method: HttpMethods.GET,
      })
      .then((project) =>
        httpClient.sendHttpRequest<void>({
          endpoint: `/projects/${projectId}`,
          method: HttpMethods.PATCH,
          data: {
            // @ts-ignore
            tags: project.tags.filter((name) => name !== tag.name),
          },
        }),
      );
}

export { removeTagFromProject };
